import qs from "qs";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { RequirementsUrlQuery } from "./hooks/useBulkReviewRequirements";

export const PATH_BULK_REVIEW_REQUIREMENTS = "/member/bulk-review/requirements";

export const useGoToBulkReviewRequirements = () => {
  const history = useHistory();

  return useCallback(
    (query: RequirementsUrlQuery) => {
      history.push({
        pathname: PATH_BULK_REVIEW_REQUIREMENTS,
        search: query ? qs.stringify(query) : undefined
      });
    },
    [history]
  );
};
